import { HttpError } from './HttpError';

/**
 * TimeoutError.
 */
export class TimeoutError extends HttpError {
  /**
   * TimeoutError constructor.
   */
  constructor() {
    const error = {
      response: {
        status: 408,
      },
    };

    super(error);
  }
}
